module.exports = __webpack_public_path__ + "img/macro1.f9ec699d.jpg";